/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import { RichText, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Pagination from "components/Shared/Pagination";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

import { saveAs } from "file-saver";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay, Mousewheel, Navigation, Pagination as Pagination1, Thumbs } from "swiper";
import axios from "axios";
import "swiper/css";

import IsRtl from "components/Shared/isRtl";
import { ShareModal } from "components/Shared/ShareModal";
import { DGAButton } from "components/Shared/dga-button/DGAButton";
import { DGACarouselArrow } from "components/Shared/dga-carousel-arrow/DGACarouselArrow";
import { scrollToTopSafe } from "src/util/ScrollTopUsingGsap";

import Loading from "components/Shared/Loading";

type CulturalLensProps = ComponentProps & {
  fields: {
    Title: {
      value: string;
    };
    Description: {
      value: string;
    };
    PlayBtnText: {
      value: string;
    };
    ModalLabels: {
      fields: {
        SharePopupTitle: {
          value: string;
        };
        SharePopupCTAText: {
          value: string;
        };
        SocialMediaTitle: {
          value: string;
        };
        DownloadButtonText: {
          value: string;
        };
        CloseButtonText: {
          value: string;
        };
        ShareButtonText: {
          value: string;
        };
      };
    };
    CloseBtnText: {
      value: string;
    };
    CancelBtnText: {
      value: string;
    };
    GridBtnText: {
      value: string;
    };
    HideBtnText: {
      value: string;
    };
    PauseBtnText: {
      value: string;
    };
    ShareModalTitle: {
      value: string;
    };
    ShareModalSocialMediaTitle: {
      value: string;
    };
    ShareModalCopyButtonText: {
      value: string;
    };
  };
  lang: any;
  locale: any;
};
const CulturalLensRendering = (props: CulturalLensProps): JSX.Element => {
  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const container = useRef<HTMLDivElement | HTMLElement | any>();

  const onPageChange = (newPage: number) => {
    setLoading(true);
    scrollToTopSafe();
    setCurrentPage(newPage);
  };

  let [isOpen, setIsOpen] = useState(false);
  // let [selectedItem, setSelectedItem]: any = useState(null);
  // let [shareModal, setShareModal]: any = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [swiper, setSwiper] = useState<any>();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [selectedSlide, setSelectedSlide] = useState(0);
  // const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [listData, setListData] = useState<any>([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [showGridForMobile, setShowGridForMobile] = useState(false);

  // Defer mounting <Image> until AFTER the grid's entrance animation finishes
  // so heavy image decode work doesn't compete with the GSAP tween on the main
  // thread. Each image then fades in individually as it finishes loading.
  const [showImages, setShowImages] = useState(false);
  const [loadedImages, setLoadedImages] = useState<Record<number, boolean>>({});

  const [showSharePopup, setShowSharePopup] = useState(false);
  const imgContainer = useRef<HTMLDivElement | HTMLElement | any>();

  const handleImageLoaded = (index: number) => {
    setLoadedImages((prev) => (prev[index] ? prev : { ...prev, [index]: true }));
  };

  const toggleAutoplay = () => {
    if (swiper) {
      if (isPlaying) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const getListData = async () => {
    try {
      const res = await axios({
        url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/CulturalLens/Moc/Get`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          culture: props?.locale,
          order: "desc",
          PageSize: currentPage - 1,
          PageNumber: itemsPerPage,
        },
      });
      setListData(res.data);
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getListData();
  }, [currentPage, props?.locale]);

  // Reset image-reveal state on every fetch and reveal images only after the
  // entrance animation has played, so the GSAP tween runs on lightweight
  // placeholder cards instead of competing with image decode work.
  useEffect(() => {
    if (loading) {
      setShowImages(false);
      setLoadedImages({});
      return;
    }
    if (!listData?.CulturalLens?.length) return;

    // GSAP duration 0.3s + small per-element stagger + a buffer for the next paint.
    const t = setTimeout(() => setShowImages(true), 600);
    return () => clearTimeout(t);
  }, [loading, listData]);

  const handleSwiperUpdate = (swiper: any) => {
    setSwiper(swiper);
  };
  const handleSlideChange = (swiper: any) => {
    setActiveSlideIndex(swiper.realIndex);
  };
  if (loading)
    return (
      <div className="py-40">
        <div className="">
          <Loading isCardList={true} itemsPerPage={itemsPerPage} />
        </div>
      </div>
    );
  if (error)
    return (
      <>
        <div className="responsive">
          <p>error in loading items</p>
        </div>
      </>
    );
  function closeModal() {
    setIsPlaying(false);
    setShowGrid(false);
    setIsOpen(false);
    setShowSharePopup(false);
    setShowGridForMobile(false);
    // setThumbsSwiper(null);
  }

  function openModal(index: number) {
    setSelectedSlide(index);
    // setSelectedItem(item);
    setIsOpen(true);
  }

  const downloadImage = async (link: string, index: any, __filename: any = "download") => {
    // const ext:any=link?.split(/[#?]/)[0].split('.')?.pop()?.trim();
    if (index == -1) {
      document.getElementById("download" + index)?.classList.add("!hidden");
      document.getElementById("loader" + index)?.classList.add("!block");
      document.getElementById("downloadd" + index)?.classList.add("!hidden");
      document.getElementById("loaderr" + index)?.classList.add("!block");
      const result = await fetch(link, {
        method: "GET",
        headers: {},
      });

      const blob = await result.blob();
      const url = URL.createObjectURL(blob);
      document.getElementById("download" + index)?.classList.remove("!hidden");
      document.getElementById("loader" + index)?.classList.remove("!block");
      document.getElementById("downloadd" + index)?.classList.remove("!hidden");
      document.getElementById("loaderr" + index)?.classList.remove("!block");
      saveAs(url, __filename);
    } else {
      document.getElementById("download" + index)?.classList.add("!hidden");
      document.getElementById("loader" + index)?.classList.add("!block");
      document.getElementById("downloadd" + index)?.classList.add("!hidden");
      document.getElementById("loaderr" + index)?.classList.add("!block");
      const result = await fetch(link, {
        method: "GET",
        headers: {},
      });

      const blob = await result.blob();
      const url = URL.createObjectURL(blob);
      document.getElementById("download" + index)?.classList.remove("!hidden");
      document.getElementById("loader" + index)?.classList.remove("!block");
      document.getElementById("downloadd" + index)?.classList.remove("!hidden");
      document.getElementById("loaderr" + index)?.classList.remove("!block");
      saveAs(url, __filename);
    }
  };

  return (
    <div ref={container} className={`${IsRtl() ? "rtl" : "ltr"}  w-full pb-20`}>
      <div className="w-full bg-primary-50 py-10">
        <h1 className="responsive text-brand-400   xl:text-4xl text-2xl font-bold ">
          {props?.fields?.Title?.value}
        </h1>

        <div className={`responsive ${props?.locale == props?.lang ? "rtl" : ""}`}>
          <RichText className="text-base pt-4" field={props?.fields?.Description} />
        </div>
      </div>
      <div className="h-full my-10 responsive animate-top-dga ">
        <div className="w-full ">

          <div
            className={`grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 mb-20 ${props?.locale == props?.lang ? "rtl" : ""
              }`}
          >
            {!error &&
              listData?.CulturalLens?.map((item: any, index: number) => {
                return (
                  <div
                    className={`border-neutral-300 border rounded-2xl p-4 cursor-pointer group relative z-10 flex flex-col justify-between [contain:layout] col-span-1 ${props?.locale == props?.lang ? "rtl " : ""
                      }`}
                    key={index}
                    onClick={() => {
                      openModal(index);
                    }}
                  >
                    <div>
                      <div className="relative min-h-[280px] h-lg:min-h-[360px] cursor-pointer z-0 rounded-md overflow-hidden bg-neutral-200">
                        {showImages && (
                          <Image
                            src={process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.image}
                            alt={item?.description?.value || item?.title?.value || `Cultural lens image ${index + 1}`}
                            layout="fill"
                            objectFit="cover"
                            objectPosition="center"
                            loading="lazy"
                            onLoadingComplete={() => handleImageLoaded(index)}
                            className={`bg-brand-1600 transition-opacity duration-500 ease-out ${loadedImages[index] ? "opacity-100" : "opacity-0"
                              }`}
                          />
                        )}
                        {(!showImages || !loadedImages[index]) && (
                          <div
                            className="absolute inset-0 flex items-center justify-center bg-neutral-200 animate-pulse"
                            aria-hidden="true"
                          >
                            <div role="status" aria-label="Loading image">
                              <svg
                                aria-hidden="true"
                                className="w-10 h-10 text-neutral-300 animate-spin fill-primary-600"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentFill"
                                />
                              </svg>
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <h2 className="text-[18px] font-medium text-neutral-800 my-4 ">
                        {item?.description?.value}
                      </h2>
                    </div>

                    <div className="flex relative z-40 flex-col">
                      <div className="flex  justify-end  relative z-100   gap-7 min-h-[33px] md:min-h-fit">
                        <div className="-mt-[2px]" aria-hidden="true"></div>

                        <DGAButton
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadImage(item?.file, index, item?.description?.value);
                          }}
                          size="iconOnly lg"
                          variant="secondarySolid"
                          className="!outline-none !ring-0 !ring-offset-0"
                          aria-label={`Download ${item?.description?.value || 'image'}`}
                          buttonContent={
                            <>
                              <span id={"download" + index}>
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M11.75 1C11.75 0.585786 11.4142 0.25 11 0.25C10.5858 0.25 10.25 0.585786 10.25 1V10.4619L10.2439 10.4548C10.0333 10.2062 9.82699 9.9434 9.63408 9.69769L9.58933 9.6407C9.39711 9.39596 9.19487 9.13885 9.03781 8.97726C8.74911 8.68023 8.27428 8.67349 7.97726 8.96219C7.68023 9.25089 7.67349 9.72572 7.96219 10.0227C8.05089 10.114 8.19651 10.2958 8.40971 10.5672L8.45677 10.6272C8.64683 10.8693 8.86981 11.1534 9.09954 11.4245C9.34574 11.715 9.62131 12.0168 9.89679 12.2515C10.0348 12.369 10.1904 12.485 10.3578 12.5746C10.5193 12.661 10.7417 12.75 11 12.75C11.2583 12.75 11.4807 12.661 11.6422 12.5746C11.8096 12.485 11.9652 12.369 12.1032 12.2515C12.3787 12.0168 12.6543 11.715 12.9005 11.4245C13.1302 11.1534 13.3531 10.8694 13.5432 10.6272L13.5903 10.5672C13.8035 10.2958 13.9491 10.114 14.0378 10.0227C14.3265 9.72572 14.3198 9.25089 14.0227 8.96219C13.7257 8.67349 13.2509 8.68023 12.9622 8.97726C12.8051 9.13885 12.6029 9.39596 12.4107 9.64069L12.366 9.69763C12.173 9.94336 11.9668 10.2061 11.7561 10.4548L11.75 10.4619V1Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.77686 7.74947C5.19081 7.73466 5.51437 7.38709 5.49957 6.97314C5.48476 6.55919 5.13719 6.23562 4.72324 6.25043C2.33578 6.33583 0.182154 8.1485 0.251636 10.7047C0.267598 11.2919 0.483009 11.9786 0.813726 13.0328L0.857728 13.1731C1.78521 16.1325 3.43179 18.9597 7.22351 19.629C7.90939 19.75 8.66853 19.75 9.98165 19.75H12.0184C13.3315 19.75 14.0907 19.75 14.7766 19.629C18.5683 18.9597 20.2149 16.1325 21.1424 13.1731L21.1863 13.0329C21.5171 11.9786 21.7325 11.2919 21.7484 10.7047C21.8179 8.14849 19.6643 6.33582 17.2768 6.25043C16.8629 6.23562 16.5153 6.55919 16.5005 6.97314C16.4857 7.38709 16.8093 7.73466 17.2232 7.74947C18.9512 7.81128 20.2919 9.08521 20.249 10.6639C20.2395 11.013 20.1008 11.4809 19.711 12.7245C18.8448 15.4882 17.477 17.6291 14.5158 18.1518C13.9756 18.2472 13.3564 18.2499 11.9303 18.2499H10.0698C8.64367 18.2499 8.02449 18.2472 7.48425 18.1518C4.52307 17.6291 3.15523 15.4882 2.28908 12.7245C1.8993 11.4809 1.76057 11.013 1.75108 10.6639C1.70817 9.08522 3.0489 7.81128 4.77686 7.74947Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              <span id={"loader" + index} className="hidden">
                                <div>
                                  <div role="status">
                                    <svg
                                      aria-hidden="true"
                                      className="inline w-[24px] h-[24px] text-gray-200 animate-spin dark:text-neutral-100 fill-primary-600"
                                      viewBox="0 0 100 101"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                      />
                                    </svg>
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </span>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

        </div>
        {!loading && (
          <div className="pagination flex justify-end">
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalItems={listData?.TotalItemsCount} // Replace with your total items count
              itemsPerPage={itemsPerPage} // Replace with your items per page count
              onPageChange={onPageChange}
              maxPages={5} // Maximum number of pages to display in pagination
              locale={props?.locale}
              lang={props?.lang}
              scrollToRef={null}
            />
          </div>
        )}

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog onClose={() => { }} as="div" className="relative !z-[99999999] ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-brand-100 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 ">
              <div className="flex min-h-full items-center justify-center text-center">
                <div className="absolute md:flex  gap-1 top-1 right-1 w-fit h-fit md:h-full">
                  <div className="flex gap-2  h-[100px] z-50 ">
                    {/*------------------------------------ play btn -------------------------------------------  */}

                    <DGAButton
                      size="lg"
                      className="!outline-none !ring-0"
                      onClick={() => toggleAutoplay()}
                      variant="primary"
                      aria-label={isPlaying ? props?.fields?.PauseBtnText?.value || "Pause autoplay" : props?.fields?.PlayBtnText?.value || "Play autoplay"}
                      buttonContent={
                        <div className="flex items-center justify-center gap-2">
                          {isPlaying ? (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.95063 3.25C6.28579 3.24997 5.71289 3.24994 5.25416 3.31161C4.76252 3.37771 4.29126 3.52677 3.90901 3.90901C3.52677 4.29126 3.37771 4.76252 3.31161 5.25416C3.24994 5.71289 3.24997 6.28574 3.25 6.95058V17.0494C3.24997 17.7142 3.24994 18.2871 3.31161 18.7458C3.37771 19.2375 3.52677 19.7087 3.90901 20.091C4.29126 20.4732 4.76252 20.6223 5.25416 20.6884C5.71291 20.7501 6.28577 20.75 6.95064 20.75H7.04937C7.71424 20.75 8.2871 20.7501 8.74585 20.6884C9.23749 20.6223 9.70875 20.4732 10.091 20.091C10.4732 19.7087 10.6223 19.2375 10.6884 18.7458C10.7501 18.2871 10.75 17.7142 10.75 17.0494V6.95064C10.75 6.28577 10.7501 5.71291 10.6884 5.25416C10.6223 4.76252 10.4732 4.29126 10.091 3.90901C9.70875 3.52677 9.23749 3.37771 8.74585 3.31161C8.28712 3.24994 7.71427 3.24997 7.04943 3.25H6.95063ZM4.96968 4.96968C5.02677 4.91258 5.12873 4.84197 5.45403 4.79823C5.80091 4.7516 6.2717 4.75001 7.00001 4.75001C7.72831 4.75001 8.1991 4.7516 8.54598 4.79823C8.87128 4.84197 8.97324 4.91258 9.03034 4.96968C9.08743 5.02677 9.15804 5.12873 9.20178 5.45403C9.24841 5.80091 9.25001 6.2717 9.25001 7.00001V17C9.25001 17.7283 9.24841 18.1991 9.20178 18.546C9.15804 18.8713 9.08743 18.9732 9.03034 19.0303C8.97324 19.0874 8.87128 19.158 8.54598 19.2018C8.1991 19.2484 7.72831 19.25 7.00001 19.25C6.2717 19.25 5.80091 19.2484 5.45403 19.2018C5.12873 19.158 5.02677 19.0874 4.96968 19.0303C4.91258 18.9732 4.84197 18.8713 4.79823 18.546C4.7516 18.1991 4.75001 17.7283 4.75001 17V7.00001C4.75001 6.2717 4.7516 5.80091 4.79823 5.45403C4.84197 5.12873 4.91258 5.02677 4.96968 4.96968Z"
                                fill="#FFFFFF"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.9506 3.25C16.2858 3.24997 15.7129 3.24994 15.2542 3.31161C14.7625 3.37771 14.2913 3.52677 13.909 3.90901C13.5268 4.29126 13.3777 4.76252 13.3116 5.25416C13.2499 5.7129 13.25 6.28576 13.25 6.95062V17.0494C13.25 17.7142 13.2499 18.2871 13.3116 18.7458C13.3777 19.2375 13.5268 19.7087 13.909 20.091C14.2913 20.4732 14.7625 20.6223 15.2542 20.6884C15.7129 20.7501 16.2858 20.75 16.9506 20.75H17.0494C17.7142 20.75 18.2871 20.7501 18.7458 20.6884C19.2375 20.6223 19.7087 20.4732 20.091 20.091C20.4732 19.7087 20.6223 19.2375 20.6884 18.7458C20.7501 18.2871 20.75 17.7143 20.75 17.0494V6.95064C20.75 6.28579 20.7501 5.7129 20.6884 5.25416C20.6223 4.76252 20.4732 4.29126 20.091 3.90901C19.7087 3.52677 19.2375 3.37771 18.7458 3.31161C18.2871 3.24994 17.7143 3.24997 17.0494 3.25H16.9506ZM14.9697 4.96968C15.0268 4.91258 15.1287 4.84197 15.454 4.79823C15.8009 4.7516 16.2717 4.75001 17 4.75001C17.7283 4.75001 18.1991 4.7516 18.546 4.79823C18.8713 4.84197 18.9732 4.91258 19.0303 4.96968C19.0874 5.02677 19.158 5.12873 19.2018 5.45403C19.2484 5.80091 19.25 6.2717 19.25 7.00001V17C19.25 17.7283 19.2484 18.1991 19.2018 18.546C19.158 18.8713 19.0874 18.9732 19.0303 19.0303C18.9732 19.0874 18.8713 19.158 18.546 19.2018C18.1991 19.2484 17.7283 19.25 17 19.25C16.2717 19.25 15.8009 19.2484 15.454 19.2018C15.1287 19.158 15.0268 19.0874 14.9697 19.0303C14.9126 18.9732 14.842 18.8713 14.7982 18.546C14.7516 18.1991 14.75 17.7283 14.75 17V7.00001C14.75 6.2717 14.7516 5.80091 14.7982 5.45403C14.842 5.12873 14.9126 5.02677 14.9697 4.96968Z"
                                fill="#FFFFFF"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M13.852 6.28676L13.9405 6.33706C15.5735 7.26475 16.8567 7.99375 17.7709 8.66154C18.6913 9.33392 19.3721 10.0367 19.6159 10.9632C19.7947 11.6427 19.7947 12.3574 19.6159 13.0369C19.3721 13.9634 18.6913 14.6662 17.7709 15.3386C16.8567 16.0064 15.5735 16.7354 13.9406 17.663L13.852 17.7134C12.2746 18.6095 11.033 19.3149 10.0232 19.7444C9.0053 20.1774 8.07729 20.3968 7.17536 20.1412C6.51252 19.9534 5.90941 19.5969 5.42356 19.1067C4.76419 18.4414 4.49951 17.522 4.37429 16.4154C4.24998 15.317 4.24999 13.879 4.25 12.0502V11.95C4.24999 10.1211 4.24998 8.68315 4.37429 7.5847C4.49951 6.47816 4.76419 5.55867 5.42356 4.89341C5.90941 4.40323 6.51252 4.04672 7.17536 3.8589C8.07729 3.60331 9.0053 3.82275 10.0232 4.25571C11.033 4.68522 12.2746 5.3906 13.852 6.28676ZM9.43611 5.63604C8.51385 5.24377 7.98374 5.18888 7.58431 5.30207C7.17108 5.41917 6.79377 5.64179 6.48892 5.94935C6.19206 6.24887 5.97861 6.74743 5.86477 7.75337C5.75115 8.75741 5.75 10.1102 5.75 12.0001C5.75 13.8899 5.75115 15.2427 5.86477 16.2467C5.97861 17.2527 6.19206 17.7513 6.48892 18.0508C6.79377 18.3583 7.17108 18.581 7.58431 18.6981C7.98374 18.8112 8.51385 18.7564 9.43611 18.3641C10.3571 17.9724 11.524 17.3108 13.1553 16.384C14.8421 15.4257 16.0497 14.7383 16.8861 14.1273C17.7244 13.5149 18.0557 13.0717 18.1653 12.6552C18.2782 12.2259 18.2782 11.7742 18.1653 11.345C18.0557 10.9285 17.7244 10.4852 16.8861 9.8728C16.0497 9.26183 14.8421 8.57445 13.1553 7.6161C11.524 6.68934 10.3571 6.02776 9.43611 5.63604Z"
                                fill="white"
                              />
                            </svg>
                          )}

                          {isPlaying
                            ? props?.fields?.PauseBtnText?.value
                            : props?.fields?.PlayBtnText?.value}
                        </div>
                      }
                    />
                    {/* ---------------------------------------grid btn desktop-------------------------------------- */}

                    <DGAButton
                      className="!outline-none !ring-0 hidden md:flex"
                      onClick={() => setShowGrid(!showGrid)}
                      variant="secondarySolid"
                      size="lg"
                      aria-label={showGrid ? props?.fields?.HideBtnText?.value || "Hide grid" : props?.fields?.GridBtnText?.value || "Show grid"}
                      buttonContent={
                        <div className="flex gap-2 items-center">
                          {showGrid ? (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                d="M11.0255 7.46487C10.73 7.17465 10.2551 7.17897 9.9649 7.47451C9.6747 7.77003 9.67922 8.24507 9.9747 8.53529L9.97595 8.53652L9.9816 8.5421L10.0051 8.56534C10.0259 8.58607 10.057 8.61705 10.0967 8.6571C10.1763 8.73722 10.2906 8.85347 10.428 8.99646C10.7035 9.28312 11.0688 9.67408 11.4324 10.095C11.7987 10.519 12.1503 10.9586 12.4061 11.3446C12.5342 11.5379 12.6281 11.7028 12.6877 11.8345C12.7308 11.9298 12.7442 11.9825 12.7482 12C12.7442 12.0176 12.7308 12.0702 12.6877 12.1656C12.6281 12.2973 12.5342 12.4621 12.4061 12.6554C12.1503 13.0414 11.7987 13.481 11.4324 13.905C11.0688 14.3259 10.7035 14.7169 10.428 15.0035C10.2906 15.1465 10.1763 15.2628 10.0967 15.3429C10.0569 15.3829 10.0259 15.4139 10.005 15.4346L9.98159 15.4579L9.97593 15.4635L9.97446 15.4649C9.67897 15.7551 9.67467 16.23 9.96487 16.5255C10.2551 16.821 10.7301 16.8252 11.0256 16.535L11.0264 16.5342L11.0356 16.5251L11.0623 16.4987C11.0854 16.4757 11.1188 16.4424 11.1611 16.3998C11.2456 16.3147 11.3657 16.1926 11.5095 16.0429C11.7965 15.7443 12.1812 15.3329 12.5676 14.8856C12.9513 14.4414 13.3497 13.9468 13.6564 13.484C13.8096 13.2529 13.95 13.0146 14.0545 12.7835C14.153 12.5656 14.25 12.2892 14.25 12C14.25 11.7108 14.153 11.4345 14.0545 11.2165C13.95 10.9854 13.8096 10.7471 13.6564 10.516C13.3497 10.0532 12.9513 9.55869 12.5676 9.11447C12.1812 8.66715 11.7965 8.25574 11.5095 7.95709C11.3657 7.80743 11.2456 7.68529 11.1611 7.60019C11.1189 7.55762 11.0855 7.52428 11.0624 7.50134L11.0357 7.47487L11.0284 7.46776L11.0255 7.46487Z"
                                fill="#161616"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                                fill="#161616"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1.75 12.0572V11.9428C1.74999 9.75212 1.74998 8.03144 1.93059 6.68802C2.11568 5.31137 2.50271 4.21911 3.36091 3.36091C4.21911 2.50271 5.31137 2.11568 6.68802 1.93059C8.03144 1.74998 9.75211 1.74999 11.9428 1.75H12.0572C14.2479 1.74999 15.9686 1.74998 17.312 1.93059C18.6886 2.11568 19.7809 2.50271 20.6391 3.36091C21.4973 4.21911 21.8843 5.31136 22.0694 6.68802C22.25 8.03143 22.25 9.7521 22.25 11.9428V12.0572C22.25 14.2479 22.25 15.9686 22.0694 17.312C21.8843 18.6886 21.4973 19.7809 20.6391 20.6391C19.7809 21.4973 18.6886 21.8843 17.312 22.0694C15.9686 22.25 14.2479 22.25 12.0572 22.25H11.9428C9.75212 22.25 8.03144 22.25 6.68802 22.0694C5.31137 21.8843 4.21911 21.4973 3.36091 20.6391C2.50272 19.7809 2.11568 18.6886 1.93059 17.312C1.74998 15.9686 1.74999 14.2479 1.75 12.0572ZM3.41722 17.1121C3.57994 18.3224 3.88853 19.0454 4.42157 19.5784C4.95462 20.1115 5.67757 20.4201 6.8879 20.5828C7.00502 20.5985 7.12565 20.6128 7.25 20.6257L7.25 15.75H3.30067C3.32544 16.2528 3.36232 16.7038 3.41722 17.1121ZM8.75 15.75L8.75 20.7196C9.66079 20.7495 10.7292 20.75 12 20.75C13.2708 20.75 14.3392 20.7495 15.25 20.7196V15.75L8.75 15.75ZM8.75 14.25V9.75H15.25L15.25 14.25L8.75 14.25ZM7.25 9.75V14.25H3.25877C3.25022 13.5785 3.25 12.8327 3.25 12C3.25 11.1673 3.25022 10.4215 3.25877 9.75H7.25ZM8.75 8.25L15.25 8.25V3.28038C14.3392 3.2505 13.2708 3.25 12 3.25C10.7292 3.25 9.66079 3.2505 8.75 3.28038L8.75 8.25ZM7.25 3.37429L7.25 8.25H3.30067C3.32544 7.74721 3.36232 7.29624 3.41722 6.8879C3.57994 5.67757 3.88853 4.95462 4.42157 4.42157C4.95462 3.88853 5.67757 3.57994 6.88789 3.41722C7.00502 3.40147 7.12565 3.38721 7.25 3.37429ZM17.1121 20.5828C16.995 20.5985 16.8744 20.6128 16.75 20.6257V15.75H20.6993C20.6746 16.2528 20.6377 16.7038 20.5828 17.1121C20.4201 18.3224 20.1115 19.0454 19.5784 19.5784C19.0454 20.1115 18.3224 20.4201 17.1121 20.5828ZM20.7412 14.25H16.75L16.75 9.75H20.7412C20.7498 10.4215 20.75 11.1673 20.75 12C20.75 12.8327 20.7498 13.5785 20.7412 14.25ZM20.6993 8.25H16.75V3.37429C16.8744 3.38721 16.995 3.40147 17.1121 3.41722C18.3224 3.57994 19.0454 3.88853 19.5784 4.42157C20.1115 4.95462 20.4201 5.67757 20.5828 6.88789C20.6377 7.29624 20.6746 7.74721 20.6993 8.25Z"
                                fill="#161616"
                              />
                            </svg>
                          )}
                          {showGrid
                            ? props?.fields?.HideBtnText?.value
                            : props?.fields?.GridBtnText?.value}
                        </div>
                      }
                    />
                    {/* -------------------------------------grid btn mobile----------------------------------------- */}
                    <button
                      onClick={() => setShowGridForMobile(!showGridForMobile)}
                      className="flex md:hidden cursor-pointer  gap-2 items-center bg-neutral-100 text-primary-1000  py-2 px-4 rounded hover:bg-neutral-200 active:bg-neutral-300"
                    >
                      {showGridForMobile ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                          <path
                            d="M11.0255 7.46487C10.73 7.17465 10.2551 7.17897 9.9649 7.47451C9.6747 7.77003 9.67922 8.24507 9.9747 8.53529L9.97595 8.53652L9.9816 8.5421L10.0051 8.56534C10.0259 8.58607 10.057 8.61705 10.0967 8.6571C10.1763 8.73722 10.2906 8.85347 10.428 8.99646C10.7035 9.28312 11.0688 9.67408 11.4324 10.095C11.7987 10.519 12.1503 10.9586 12.4061 11.3446C12.5342 11.5379 12.6281 11.7028 12.6877 11.8345C12.7308 11.9298 12.7442 11.9825 12.7482 12C12.7442 12.0176 12.7308 12.0702 12.6877 12.1656C12.6281 12.2973 12.5342 12.4621 12.4061 12.6554C12.1503 13.0414 11.7987 13.481 11.4324 13.905C11.0688 14.3259 10.7035 14.7169 10.428 15.0035C10.2906 15.1465 10.1763 15.2628 10.0967 15.3429C10.0569 15.3829 10.0259 15.4139 10.005 15.4346L9.98159 15.4579L9.97593 15.4635L9.97446 15.4649C9.67897 15.7551 9.67467 16.23 9.96487 16.5255C10.2551 16.821 10.7301 16.8252 11.0256 16.535L11.0264 16.5342L11.0356 16.5251L11.0623 16.4987C11.0854 16.4757 11.1188 16.4424 11.1611 16.3998C11.2456 16.3147 11.3657 16.1926 11.5095 16.0429C11.7965 15.7443 12.1812 15.3329 12.5676 14.8856C12.9513 14.4414 13.3497 13.9468 13.6564 13.484C13.8096 13.2529 13.95 13.0146 14.0545 12.7835C14.153 12.5656 14.25 12.2892 14.25 12C14.25 11.7108 14.153 11.4345 14.0545 11.2165C13.95 10.9854 13.8096 10.7471 13.6564 10.516C13.3497 10.0532 12.9513 9.55869 12.5676 9.11447C12.1812 8.66715 11.7965 8.25574 11.5095 7.95709C11.3657 7.80743 11.2456 7.68529 11.1611 7.60019C11.1189 7.55762 11.0855 7.52428 11.0624 7.50134L11.0357 7.47487L11.0284 7.46776L11.0255 7.46487Z"
                            fill="#161616"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                            fill="#161616"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.75 12.0572V11.9428C1.74999 9.75212 1.74998 8.03144 1.93059 6.68802C2.11568 5.31137 2.50271 4.21911 3.36091 3.36091C4.21911 2.50271 5.31137 2.11568 6.68802 1.93059C8.03144 1.74998 9.75211 1.74999 11.9428 1.75H12.0572C14.2479 1.74999 15.9686 1.74998 17.312 1.93059C18.6886 2.11568 19.7809 2.50271 20.6391 3.36091C21.4973 4.21911 21.8843 5.31136 22.0694 6.68802C22.25 8.03143 22.25 9.7521 22.25 11.9428V12.0572C22.25 14.2479 22.25 15.9686 22.0694 17.312C21.8843 18.6886 21.4973 19.7809 20.6391 20.6391C19.7809 21.4973 18.6886 21.8843 17.312 22.0694C15.9686 22.25 14.2479 22.25 12.0572 22.25H11.9428C9.75212 22.25 8.03144 22.25 6.68802 22.0694C5.31137 21.8843 4.21911 21.4973 3.36091 20.6391C2.50272 19.7809 2.11568 18.6886 1.93059 17.312C1.74998 15.9686 1.74999 14.2479 1.75 12.0572ZM3.41722 17.1121C3.57994 18.3224 3.88853 19.0454 4.42157 19.5784C4.95462 20.1115 5.67757 20.4201 6.8879 20.5828C7.00502 20.5985 7.12565 20.6128 7.25 20.6257L7.25 15.75H3.30067C3.32544 16.2528 3.36232 16.7038 3.41722 17.1121ZM8.75 15.75L8.75 20.7196C9.66079 20.7495 10.7292 20.75 12 20.75C13.2708 20.75 14.3392 20.7495 15.25 20.7196V15.75L8.75 15.75ZM8.75 14.25V9.75H15.25L15.25 14.25L8.75 14.25ZM7.25 9.75V14.25H3.25877C3.25022 13.5785 3.25 12.8327 3.25 12C3.25 11.1673 3.25022 10.4215 3.25877 9.75H7.25ZM8.75 8.25L15.25 8.25V3.28038C14.3392 3.2505 13.2708 3.25 12 3.25C10.7292 3.25 9.66079 3.2505 8.75 3.28038L8.75 8.25ZM7.25 3.37429L7.25 8.25H3.30067C3.32544 7.74721 3.36232 7.29624 3.41722 6.8879C3.57994 5.67757 3.88853 4.95462 4.42157 4.42157C4.95462 3.88853 5.67757 3.57994 6.88789 3.41722C7.00502 3.40147 7.12565 3.38721 7.25 3.37429ZM17.1121 20.5828C16.995 20.5985 16.8744 20.6128 16.75 20.6257V15.75H20.6993C20.6746 16.2528 20.6377 16.7038 20.5828 17.1121C20.4201 18.3224 20.1115 19.0454 19.5784 19.5784C19.0454 20.1115 18.3224 20.4201 17.1121 20.5828ZM20.7412 14.25H16.75L16.75 9.75H20.7412C20.7498 10.4215 20.75 11.1673 20.75 12C20.75 12.8327 20.7498 13.5785 20.7412 14.25ZM20.6993 8.25H16.75V3.37429C16.8744 3.38721 16.995 3.40147 17.1121 3.41722C18.3224 3.57994 19.0454 3.88853 19.5784 4.42157C20.1115 4.95462 20.4201 5.67757 20.5828 6.88789C20.6377 7.29624 20.6746 7.74721 20.6993 8.25Z"
                            fill="#161616"
                          />
                        </svg>
                      )}
                      {showGridForMobile
                        ? props?.fields?.HideBtnText?.value
                        : props?.fields?.GridBtnText?.value}
                    </button>
                    {/* ----------------------------------------cancel btn------------------------------------------ */}

                    <DGAButton
                      className="!outline-none !ring-0"
                      onClick={() => closeModal()}
                      size="lg"
                      variant="secondarySolid"
                      buttonContent={
                        <div className="flex items-center gap-2">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L8 6.93934L14.4697 0.46967C14.7626 0.176777 15.2374 0.176777 15.5303 0.46967C15.8232 0.762563 15.8232 1.23744 15.5303 1.53033L9.06066 8L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L8 9.06066L1.53033 15.5303C1.23744 15.8232 0.762563 15.8232 0.46967 15.5303C0.176777 15.2374 0.176777 14.7626 0.46967 14.4697L6.93934 8L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
                              fill="#161616"
                            />
                          </svg>
                          {props?.fields?.CancelBtnText?.value}
                        </div>
                      }
                    />
                    {/* ------------------------------------------------------------------------------------------- */}
                  </div>
                  <div
                    className={`h-full w-0 images-container transform transition-all delay-150 md:bg-white ${showGrid ? "w-[150px] lg:!w-[400px] " : ""
                      } ${showGridForMobile ? "!w-[95vw]" : ""}`}
                  >
                    <div className="w-full h-fit max-h-[95vh] overflow-y-auto flex gap-2 justify-start items-center flex-wrap p-2 ">
                      {listData?.CulturalLens?.map((item: any, index: number) => {
                        return (
                          <div
                            key={index}
                            className="cursor-pointer relative rounded-lg overflow-hidden w-full  md:max-w-[48%] "
                          >
                            <img
                              onClick={() => {
                                setSelectedSlide(index);
                                swiper?.slideTo(index);
                              }}
                              src={process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.image}
                              alt={item?.description?.value || item?.title?.value || `Cultural lens thumbnail ${index + 1}`}
                              height={60}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel
                    className={`h-auto ${showGrid ? "translate-x-[-100px] lg:translate-x-[-200px]" : ""
                      } xl:h-screen transform  w-[calc(100vw-300px)]  lg:w-[calc(100vw-500px)] overflow-visible  duration-500  bg-transparent  text-left align-middle  transition-all`}
                  >
                    <div
                      className={`flex justify-center h-full max-w-full items-center flex-col ${props?.locale == props?.lang ? "rtl" : ""
                        }`}
                    >
                      <div className={`flex flex-row-reverse  `}>
                        <div className="flex w-fit h-auto lg:h-full gap-4">
                          <div
                            className={`h-auto relative z-30  hidden justify-center items-center md:flex `}
                          >
                            <DGACarouselArrow
                              onClick={() => {
                                swiper?.slidePrev();
                              }}
                              direction={IsRtl() ? "right" : "left"}
                              size="large"
                              style="primary"
                              disabled={swiper?.isBeginning}
                            />
                          </div>
                          <div
                            className={`max-w-[50vw]  !h-auto ${showGridForMobile ? "hidden" : ""}`}
                          >
                            <Swiper
                              onInit={(ev) => {
                                setSwiper(ev as any);
                                // setThumbsSwiper(ev)
                              }}
                              dir={props?.locale == props?.lang ? "rtl" : ""}
                              key={props?.locale == props?.lang ? "true" : "false"}
                              onSwiper={handleSwiperUpdate}
                              slidesPerView={1}
                              spaceBetween={0}
                              speed={900}
                              allowTouchMove={true}
                              resistanceRatio={0}
                              navigation={false}
                              mousewheel={{ thresholdDelta: 100, forceToAxis: false }}
                              // thumbs={{ swiper: thumbsSwiper }}
                              initialSlide={selectedSlide}
                              onSlideChange={handleSlideChange}
                              modules={[Navigation, Mousewheel, Thumbs, Autoplay, Pagination1, A11y]}
                              pagination={{ clickable: true, el: "#lens-pagination" }}
                              a11y={{
                                enabled: true,
                                paginationBulletMessage: "Go to slide {{index}}",
                              }}
                              autoplay={{
                                delay: 3000, // Time between slides in ms
                                disableOnInteraction: false, // Keep autoplay even after user interaction
                              }}
                              className={`
                            [&>.swiper-button-next]:scale-50 [&>.swiper-button-next]:text-white
                          [&>.swiper-button-prev]:text-white [&>.swiper-button-prev]:scale-50
                          [&>.swiper-button-disabled]:!opacity-0 [&>.swiper-button-disabled]:transition-opacity
                          [&>.swiper-button-disabled]:ease-out [&>.swiper-button-disabled]:duration-300
                          [&>.swiper-button-prev]:hidden [&>.swiper-button-next]:hidden
                          md:[&>.swiper-button-prev]:block md:[&>.swiper-button-next]:block
                          ${props?.locale == props?.lang
                                  ? "xl:[&>.swiper-button-next]:!left-[20px] xl:[&>.swiper-button-prev]:!right-[20px]"
                                  : "xl:[&>.swiper-button-next]:right-[20px] xl:[&>.swiper-button-prev]:left-[20px]"
                                }
                          `}
                            >
                              {listData?.CulturalLens?.map((item: any, index: number) => {
                                return (
                                  <SwiperSlide
                                    key={index}
                                    className="pt-4 px-4 pb-16 bg-white rounded-2xl"
                                  >
                                    <div
                                      ref={imgContainer}
                                      className="relative h-[282px] w-full sm:h-[382px] rounded-lg  h-md:lg:h-[562px] text-center m-auto "
                                    >
                                      <Image
                                        src={
                                          process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.image
                                        }
                                        alt={item?.description?.value || item?.title?.value || `Cultural lens image ${index + 1}`}
                                        className="aspect-[1.5] rounded-lg"
                                        layout="fill"
                                        objectPosition={"top center"}
                                        objectFit="cover"
                                      />
                                    </div>
                                    <div className="absolute z-50 bottom-3 w-full flex justify-between px-4">
                                      <div className="">
                                        <button
                                          onClick={() => setShowSharePopup(true)}
                                          className="cursor-pointer flex gap-2 justify-center items-center bg-white hover:bg-neutral-100 active:bg-neutral-200 border-[1px] rounded border-[] text-[16px] py-2 px-4"
                                          aria-label={props?.fields?.ModalLabels?.fields?.ShareButtonText?.value || "Share image"}
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M15 2.28906C13.2741 2.28906 11.875 3.68817 11.875 5.41406C11.875 5.65262 11.9017 5.88493 11.9524 6.10817L7.52247 8.15237C6.95387 7.37632 6.03578 6.8724 5 6.8724C3.27411 6.8724 1.875 8.27151 1.875 9.9974C1.875 11.7233 3.27411 13.1224 5 13.1224C6.03575 13.1224 6.95381 12.6185 7.52242 11.8425L11.9523 13.8867C11.9017 14.1099 11.875 14.3422 11.875 14.5807C11.875 16.3066 13.2741 17.7057 15 17.7057C16.7259 17.7057 18.125 16.3066 18.125 14.5807C18.125 12.8548 16.7259 11.4557 15 11.4557C13.9587 11.4557 13.0363 11.9651 12.4684 12.7482L8.04418 10.7066C8.09705 10.4787 8.125 10.2413 8.125 9.9974C8.125 9.75349 8.09706 9.51611 8.0442 9.28829L12.4685 7.24668C13.0364 8.02976 13.9587 8.53906 15 8.53906C16.7259 8.53906 18.125 7.13995 18.125 5.41406C18.125 3.68817 16.7259 2.28906 15 2.28906ZM13.125 5.41406C13.125 4.37853 13.9645 3.53906 15 3.53906C16.0355 3.53906 16.875 4.37853 16.875 5.41406C16.875 6.4496 16.0355 7.28906 15 7.28906C13.9645 7.28906 13.125 6.4496 13.125 5.41406ZM3.125 9.9974C3.125 8.96186 3.96447 8.1224 5 8.1224C6.03553 8.1224 6.875 8.96186 6.875 9.9974C6.875 11.0329 6.03553 11.8724 5 11.8724C3.96447 11.8724 3.125 11.0329 3.125 9.9974ZM15 12.7057C13.9645 12.7057 13.125 13.5452 13.125 14.5807C13.125 15.6163 13.9645 16.4557 15 16.4557C16.0355 16.4557 16.875 15.6163 16.875 14.5807C16.875 13.5452 16.0355 12.7057 15 12.7057Z"
                                              fill="#161616"
                                            />
                                          </svg>
                                          <span className="hidden md:block">
                                            {
                                              props?.fields?.ModalLabels?.fields?.ShareButtonText
                                                ?.value
                                            }
                                          </span>
                                        </button>
                                      </div>
                                      <div className=" flex gap-2 px-0">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            downloadImage(
                                              item?.image,
                                              index,
                                              item?.description?.value
                                            );
                                          }}
                                          className=" bg-white hover:bg-neutral-100 active:bg-neutral-200 border-[1px] rounded text-[16px] py-2 px-4"
                                          aria-label={`Download ${item?.description?.value || 'image'}`}
                                        >
                                          <a className="cursor-pointer  flex gap-2 justify-center items-center">
                                            <svg
                                              id={"downloadd" + index}
                                              width="22"
                                              height="20"
                                              viewBox="0 0 22 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              aria-hidden="true"
                                            >
                                              <path
                                                className="group-hover:stroke-[#8f8f8f] transition-colors duration-300 ease-in-out"
                                                d="M11.75 1C11.75 0.585786 11.4142 0.25 11 0.25C10.5858 0.25 10.25 0.585786 10.25 1V10.4619L10.2439 10.4548C10.0333 10.2062 9.82699 9.9434 9.63408 9.69769L9.58933 9.6407C9.39711 9.39596 9.19487 9.13885 9.03781 8.97726C8.74911 8.68023 8.27428 8.67349 7.97726 8.96219C7.68023 9.25089 7.67349 9.72572 7.96219 10.0227C8.05089 10.114 8.19651 10.2958 8.40971 10.5672L8.45677 10.6272C8.64683 10.8693 8.86981 11.1534 9.09954 11.4245C9.34574 11.715 9.62131 12.0168 9.89679 12.2515C10.0348 12.369 10.1904 12.485 10.3578 12.5746C10.5193 12.661 10.7417 12.75 11 12.75C11.2583 12.75 11.4807 12.661 11.6422 12.5746C11.8096 12.485 11.9652 12.369 12.1032 12.2515C12.3787 12.0168 12.6543 11.715 12.9005 11.4245C13.1302 11.1534 13.3531 10.8694 13.5432 10.6272L13.5903 10.5672C13.8035 10.2958 13.9491 10.114 14.0378 10.0227C14.3265 9.72572 14.3198 9.25089 14.0227 8.96219C13.7257 8.67349 13.2509 8.68023 12.9622 8.97726C12.8051 9.13885 12.6029 9.39596 12.4107 9.64069L12.366 9.69763C12.173 9.94336 11.9668 10.2061 11.7561 10.4548L11.75 10.4619V1Z"
                                                fill="#161616"
                                              />
                                              <path
                                                className="group-hover:stroke-[#8f8f8f] transition-colors duration-300 ease-in-out"
                                                d="M4.77686 7.74947C5.19081 7.73466 5.51437 7.38709 5.49957 6.97314C5.48476 6.55919 5.13719 6.23562 4.72324 6.25043C2.33578 6.33583 0.182154 8.1485 0.251636 10.7047C0.267598 11.2919 0.483009 11.9786 0.813726 13.0328L0.857728 13.1731C1.78521 16.1325 3.43179 18.9597 7.22351 19.629C7.90939 19.75 8.66853 19.75 9.98165 19.75H12.0184C13.3315 19.75 14.0907 19.75 14.7766 19.629C18.5683 18.9597 20.2149 16.1325 21.1424 13.1731L21.1863 13.0329C21.5171 11.9786 21.7325 11.2919 21.7484 10.7047C21.8179 8.14849 19.6643 6.33582 17.2768 6.25043C16.8629 6.23562 16.5153 6.55919 16.5005 6.97314C16.4857 7.38709 16.8093 7.73466 17.2232 7.74947C18.9512 7.81128 20.2919 9.08521 20.249 10.6639C20.2395 11.013 20.1008 11.4809 19.711 12.7245C18.8448 15.4882 17.477 17.6291 14.5158 18.1518C13.9756 18.2472 13.3564 18.2499 11.9303 18.2499H10.0698C8.64367 18.2499 8.02449 18.2472 7.48425 18.1518C4.52307 17.6291 3.15523 15.4882 2.28908 12.7245C1.8993 11.4809 1.76057 11.013 1.75108 10.6639C1.70817 9.08522 3.0489 7.81128 4.77686 7.74947Z"
                                                fill="#161616"
                                              />
                                            </svg>
                                            <span id={"loaderr" + index} className="hidden">

                                              <div>
                                                <div role="status">
                                                  <svg
                                                    aria-hidden="true"
                                                    className="inline w-[24px] h-[24px] text-gray-200 animate-spin dark:text-neutral-100 fill-primary-600"
                                                    viewBox="0 0 100 101"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                      fill="currentColor"
                                                    />
                                                    <path
                                                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                      fill="currentFill"
                                                    />
                                                  </svg>
                                                  <span className="sr-only">Loading...</span>
                                                </div>
                                              </div>

                                            </span>
                                            <span className="hidden md:block">
                                              {
                                                props?.fields?.ModalLabels?.fields
                                                  ?.DownloadButtonText?.value
                                              }{" "}
                                            </span>
                                          </a>
                                        </button>
                                        <button
                                          onClick={() => closeModal()}
                                          className="hidden md:flex gap-2 justify-center items-center bg-white hover:bg-neutral-100 active:bg-neutral-200 border-[1px] rounded border-[] text-[16px] py-2 px-4"
                                          aria-label={props?.fields?.CloseBtnText?.value || "Close modal"}
                                        >
                                          {props?.fields?.CloseBtnText?.value}
                                        </button>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                            <div
                              id="lens-pagination"
                              className={`md:!w-fit custom_swiper mx-auto md:mx-0 absolute  !bottom-[0px]  md:!bottom-0 !justify-center !gap-[2px]`}
                            />
                          </div>
                          <div className={`h-auto hidden justify-center items-center  md:flex `}>
                            <DGACarouselArrow
                              direction={IsRtl() ? "left" : "right"}
                              size="large"
                              style="primary"
                              onClick={() => {
                                swiper?.slideNext();
                              }}
                              disabled={swiper?.isEnd}
                            />
                          </div>
                        </div>
                      </div>

                      {showSharePopup && (
                        <ShareModal
                          contentRef={imgContainer}
                          setShowShare={setShowSharePopup}
                          selectedItem={{
                            file:
                              process.env.PUBLIC_URL +
                              listData?.CulturalLens[activeSlideIndex]?.image,
                          }}
                          shareCardCopyButtonText={
                            props?.fields?.ModalLabels?.fields?.SharePopupCTAText?.value
                          }
                          shareCardTitle={
                            props?.fields?.ModalLabels?.fields?.SharePopupTitle?.value
                          }
                          SocialMediaTitle={
                            props?.fields?.ModalLabels?.fields?.SocialMediaTitle?.value
                          }
                          hideOverlay={true}
                        />
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </div>
  );
};

export default withDatasourceCheck()<CulturalLensProps>(CulturalLensRendering);
